import { render } from "./CostoCreate.vue?vue&type=template&id=25500c81&scoped=true"
import script from "./CostoCreate.vue?vue&type=script&lang=js"
export * from "./CostoCreate.vue?vue&type=script&lang=js"

import "./CostoCreate.vue?vue&type=style&index=0&id=25500c81&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\clogistica_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25500c81"]])

export default __exports__